export const ModalType = {
  Post: "post",
  Put: "put",
  Group: "group",
  Role: "role",
  ServiceAccountPost: "service_account.post",
  ServiceAccountPut: "service_account.put",
};
